import apiSlice from "./apiSlice";

const wbsLevelApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getWbsLevel: builder.query({
            query: (req) => ({
                url: `schedule/wbs-level`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getActivityDprData: builder.query({
            query: (req) => ({
                url: `schedule/dpr-data`,
                params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        quantityDPR: builder.mutation({
            query: (body) => ({
                url: `quantity-dpr/`,
                method: 'POST',
                body,
            })
        }),
    }),
});

export const {
    useGetWbsLevelQuery,
    useLazyGetActivityDprDataQuery,
    useQuantityDPRMutation
} = wbsLevelApiSlice;
